"use client";

import RenderUserAvatar from "../../../common/RenderUserAvatar";
import { userIcon } from "../../../../assets";
import { useAuth } from "../../../../lib/services/auth-session-service";
import { useIpDetails } from "../../../../lib/services/location-service";
import { getLoggedinUser } from "../../../../lib/util";
import { useAppDispatch, useAppSelector } from "../../../slice/hooks";
import { getActiveUser, logOutUser, logTempToken } from "../../../slice/auth-slice";
import { useHistoryManager } from "../../../history/useHistoryManager";
import Dropdown from "../../../dropdown/Dropdown";
import styles from "./index.module.scss";

const UserLoginSwitch = ({
  onLogout,
  handleLoginClick,
  dropdownMode = false,
  storePath,
}) => {
  const dispatch = useAppDispatch();
  const { data: ipDetails, isSuccess } = useIpDetails();

  const { loggedInUser } = useAppSelector((state) =>
    getActiveUser(state, getLoggedinUser()),
  );

  const { logUserOut } = useAuth();
  const { navigateTo } = useHistoryManager(storePath);

  const handleLogout = async () => {
    dispatch(logOutUser());
    const geo = isSuccess ? ipDetails : null;
    const { token, tokenExpiryDate } = await logUserOut(geo);
    dispatch(logTempToken({ token, tokenExpiryDate }));
    onLogout?.();
  };

  const handleProfileClick = () => {
    navigateTo("profile/account", { urlData: { subPath: "account" } });
  };

  const handleOrderClick = () => {
    navigateTo("profile/orders", { urlData: { subPath: "orders" } });
  };

  const menuOptions = [
    { key: "profile", label: "Profile", action: handleProfileClick },
    { key: "orders", label: "Orders", action: handleOrderClick },
    { key: "logout", label: "Logout", action: handleLogout },
  ];

  const firstName = loggedInUser?.user?.firstName || "User";

  const renderUserSection = () => {
    if (!dropdownMode) {
      return (
        <div className={styles.convetiUserInfo}>
          <RenderUserAvatar user={loggedInUser.user} />
          <span className={styles.convetiUserGreeting}>Hi, {firstName}</span>
          <button
            type="button"
            className={styles.convetiLogoutButton}
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      );
    }

    return (
      <Dropdown
        options={menuOptions}
        value={null}
        getOptionValue={(opt) => opt.key}
        getOptionLabel={(opt) => opt.label}
        onSelect={(opt) => opt.action()}
        className={styles.convetiUserDropdown}
        listClassName={styles.convetiUserDropdownList}
      >
        <button type="button" className={styles.convetiUserTrigger}>
          <RenderUserAvatar user={loggedInUser.user} />
          <span>{firstName}</span>
          <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="m6 9 6 6 6-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        </button>
      </Dropdown>
    );
  };

  const renderGuestSection = () => (
    <>
      <button
        type="button"
        className={styles.convetiLoginButton}
        onClick={handleLoginClick}
      >
        Sign in
      </button>
      <button
        type="button"
        className={styles.convetiLoginIcon}
        onClick={handleLoginClick}
        aria-label="Sign in"
      >
        {userIcon}
      </button>
    </>
  );

  return (
    <div className={styles.convetiUserLoginSwitch}>
      {loggedInUser?.user ? renderUserSection() : renderGuestSection()}
    </div>
  );
};

export default UserLoginSwitch;
